@if(screenMessage !== '')
{
<!-- display any error messages -->
<div class="container">
    <p class="text-danger text-center">{{screenMessage}}</p>
</div>
}

@if(isSearching)
{
<!-- display spinner while searching -->
<div class="container">
    <div class="row justify-content-center col-sm-12">
        @if(chevronApp == null)
        {
        <p>Searching for associated keyvaults to {{serviceId}}...</p>
        }
        @else
        {
        <p>Loading associated keyvault names...</p>
        }
    </div>
    <div class="row justify-content-center col-sm-12">
        <mat-spinner></mat-spinner>
    </div>
</div>
}
@else
{

@if(chevronApp !== null)
{

<section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
    <div class="row">
        <div class="col col-12">
            <fieldset class="pb-3">
                <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                    <p><strong>chevron application</strong></p>
                </legend>
                <display-form [displayObject]="chevronApp" />
            </fieldset>

            @if(associatedKeyvaultNames.length > 0)
            {
            <form class="branded" [formGroup]="configForm">
                <fieldset class="pb-4">
                    <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                        <p><strong>define config</strong></p>
                    </legend>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <alert-warning-message>
                                    If you define a config, the client secret will be auto-rotated in the specified
                                    keyvault prior to expiration <a [href]="clientSecretAutoRotationConfigLink"
                                        target="_blank">{{clientSecretAutoRotationConfigLink}}</a>.
                                </alert-warning-message>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-6">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>keyvault name</mat-label>
                                    <mat-select formControlName="keyvaultName"
                                        (selectionChange)="keyvaultSelectionChanged($event);">
                                        <!--  -->
                                        <mat-option *ngFor="let keyvaultName of associatedKeyvaultNames"
                                            [value]="keyvaultName">{{
                                            keyvaultName }}</mat-option>
                                    </mat-select>
                                    @if(configForm.controls.keyvaultName.hasError('required'))
                                    {
                                    <mat-error>This is a required field</mat-error>
                                    }
                                </mat-form-field>
                            </div>

                            <div class="col-12 col-md-6 col-lg-6">
                                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                                    <mat-label>secret name</mat-label>
                                    <input
                                        [matTooltip]="'secret name to be update in the keyvault. ' + requiredAppIdSuffix + ' will be appended to this value'"
                                        matInput formControlName="keyvaultSecretName" />
                                    <div style="padding-right: 5px;" matSuffix class="suffix-text">
                                        {{truncatedAppIdSuffix}}...</div>
                                    @if(configForm.controls.keyvaultSecretName.hasError('required'))
                                    {
                                    <mat-error>This is a required field</mat-error>
                                    }
                                    @if(configForm.controls.keyvaultSecretName.hasError('pattern'))
                                    {
                                    <mat-error>Secret name must consist of alphanumeric characters</mat-error>
                                    }
                                    @if(configForm.controls.keyvaultSecretName.hasError('maxlength'))
                                    {
                                    <mat-error>Secret name must be no more than {{
                                        configForm.controls.keyvaultSecretName.errors
                                        ?.maxlength.requiredLength
                                        }} characters</mat-error>
                                    }
                                </mat-form-field>
                                <button
                                    [disabled]="configForm.controls.keyvaultSecretName.status != 'VALID' || keyvaultSecretName.length === 0"
                                    mat-flat-button color="primary" (click)="addConfig()" class="add-button float-right"
                                    type="button">
                                    <mat-icon>add</mat-icon> config
                                </button>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>

            <display-http-error [message]="keyvaultConfigsErrorMessage" [errors]="[]"></display-http-error>
            }
            @else
            {
            <display-http-error [message]="'no keyvaults associated with serviceId '+ serviceId + ' found in Orion'"
                [errors]="[]"></display-http-error>
            }

            @if(newClientSecretAutoRotationConfig.length > 0)
            {
            <fieldset class="pb-4">
                <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white">
                    <p><strong>new configs</strong></p>
                </legend>
                <generic-search-results [showHeader]="false" [records]="newClientSecretAutoRotationConfig"
                    [showCounter]="false" [title]="''" [caption]="'configs to add'"
                    [displayedColumns]="keyvaultConfigsDisplayedColumns" [selectableRecords]="false"
                    [deletableRecords]="true" [showPagination]="false" [allowLocalFilter]="false"
                    (recordDeleted)="removeConfig($event)">
                </generic-search-results>
            </fieldset>
            }
            <mat-divider></mat-divider>
        </div>
    </div>
</section>

}
@else
{
<display-http-error [message]="'serviceId ' + serviceId + ' could not be found in Orion'"
    [errors]="[]"></display-http-error>
}

<!-- display buttons -->
<div class="btn-toolbar d-flex justify-content-center pt-4" role="toolbar">

    @if(newClientSecretAutoRotationConfig.length > 0)
    {
    <!-- let the user save the defined configs -->
    <div class="btn-group mr-2" role="group">
        <button class="button" type="button" (click)="saveConfig()">add configs</button>
    </div>
    }

    <!-- let the user close the form -->
    <div class="btn-group mr-2" role="group" [hidden]="!isDialog">
        <button class="button" type="button" mat-dialog-close>close</button>
    </div>
</div>
}